// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { LazyImage, LazyImageProps } from "@rugby/MobiusOverrides/LazyImage/LazyImage";
import React from "react";
import { ThemeContext } from "styled-components";

/**
 * Xng Picture Component
 */
export class LazyPicture extends LazyImage {
    static contextType = ThemeContext;

    hasInvalidProps() {
        const { largeImageSrc, mediumImageSrc, smallImageSrc } = this.props as LazyImageProps;
        return !largeImageSrc && !mediumImageSrc && !smallImageSrc;
    }

    renderImage(src?: string) {
        const { pictureProps, largeImageSrc, mediumImageSrc, smallImageSrc } = this.props as LazyImageProps;
        return (
            <picture {...pictureProps}>
                <source media={`(min-width: ${this.context.breakpoints.values[3]}px)`} data-srcset={largeImageSrc} />
                <source media={`(min-width: ${this.context.breakpoints.values[2]}px)`} data-srcset={mediumImageSrc} />
                {super.renderImage(smallImageSrc)}
            </picture>
        );
    }
}

/** @component */
export default LazyPicture;
